
        import 'LoginHeader.3e7827f.css-module'
        export default {"header":"header_LoginHeader_3e7827f"}
    